import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IUserNameAvailability {
  username: string;
  existsOnServer?: boolean;
  existsOnSite?: boolean;
  displayName: string;
  userAuthSetting?: string; //value should match SiteUserAuthSetting values
}

export interface ICheckUserNamesParams {
  usernames: string[];
}

export interface ICheckUserNamesResult extends IResult {
  users: IUserNameAvailability[];
}

export class CheckUserNamesRequest extends Request<ICheckUserNamesParams, ICheckUserNamesResult> {
  constructor(params: ICheckUserNamesParams) {
    super('checkUserNames', params);
  }
}
